var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhostLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) scale(2.34375)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h213.333v213.333H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.666 213.333c29.868 0 65.97-1.552 85.334-21.333 18.827-19.235 21.333-56.291 21.333-85.334 0-29.5-1.979-66.023-21.333-85.333C172.704 2.083 136.076 0 106.666 0 77.244 0 40.631 2.068 21.333 21.333 1.993 40.641 0 77.18 0 106.666 0 136.516 1.573 172.64 21.333 192c19.239 18.849 56.272 21.333 85.333 21.333z",
    fill: "#15171a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.068 32.599c40.988 0 74.265 33.07 74.265 73.803 0 40.734-33.277 73.804-74.265 73.804s-74.265-33.07-74.265-73.804c0-40.733 33.277-73.803 74.265-73.803zM48.455 90.828c3.712-30.573 20.106-45.77 57.077-49.899 17.628-1.97 37.644 12.923 43.296 19.783 11.422 13.86 25.838 30.357 25.838 48.936 0 25.048-20.193 39.112-41.732 50.565-9.708 5.161-20.196 10.157-32.176 10.157-30.789 0-56.703-24.029-56.703-54.628 0-8.133 3.382-16.544 4.4-24.914z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.666 186.832c44.919 0 81.334-36.188 81.334-80.828s-36.415-80.828-81.334-80.828c-44.918 0-81.333 36.188-81.333 80.828s36.415 80.828 81.333 80.828zm0-8.98c39.928 0 72.296-32.168 72.296-71.848s-32.368-71.847-72.296-71.847c-39.928 0-72.295 32.167-72.295 71.847 0 39.68 32.367 71.848 72.295 71.848z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostLogo);
export default __webpack_public_path__ + "static/media/ghost-logo.a648e13acfd8acd2dc345d1b1b5a34fd.svg";
export { ForwardRef as ReactComponent };